/*
 * CalloutIcon paints its disc and glyph from two custom properties that the
 * library sets with a triple-class selector. Repeat our class to outrank it
 * and point both at the app's accent tokens. See WBAgentIcons.tsx.
 */
.wbagent-accent-callout.wbagent-accent-callout.wbagent-accent-callout
  [data-component='CalloutIcon'] {
  --background-color: var(--wb-accent-icon-bg);
  --icon-color: var(--wb-accent-icon);
}
